define( [
	"./arr"
], function( arr ) {
	return arr.indexOf;
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/var/indexOf.js
 ** module id = 419
 ** module chunks = 2
 **/